import { render, staticRenderFns } from "./ProductContentPage.vue?vue&type=template&id=69d6cddc&scoped=true&"
import script from "./ProductContentPage.vue?vue&type=script&lang=js&"
export * from "./ProductContentPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentPage.vue?vue&type=style&index=0&id=69d6cddc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d6cddc",
  null
  
)

export default component.exports